import { Link } from 'react-router-dom';

export const generateLabel = ({
  label,
  route,
  isExternal = false,
}: {
  label: string;
  route: string;
  isExternal?: boolean;
}) => {
  if (!route) {
    return label;
  }

  // NOTE: Weirdly, i believe ant expects an anchor tag <a> over their Typography.Link component
  // when used inside of Menu labels. Otherwise, the tooltip on the item when it is collapsed
  // has the incorrect background color.
  // For external URLs (full URLs with protocol), use <a> tag instead of React Router Link
  if (isExternal) {
    return (
      <a href={route} rel="noopener noreferrer">
        {label}
      </a>
    );
  }

  return (
    <Link to={route} rel="noopener noreferrer">
      {label}
    </Link>
  );
};
